import { useSite } from "@/lib/site";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloating() {
  const { settings } = useSite();
  const number = settings?.whatsapp_number?.replace(/\D/g, "");
  if (!number) return null;
  const href = `https://wa.me/${number}?text=${encodeURIComponent("Hello Durga Auto Industries, I'd like to enquire about your fasteners.")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-floating-cta"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_0_24px_rgba(37,211,102,0.45)] hover:scale-110 transition-transform animate-pulse-ring"
    >
      <MessageCircle size={26} />
    </a>
  );
}
